import { Component, OnInit } from '@angular/core';
import {
  Cohortes,
  CourseraDashboardStats,
  GenderStats,
} from '../../service/coursera-dashboard-stats.model';
import { CourseraDashboardService } from '../../service/coursera-dashboard.service';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { ActivatedRoute, Route } from '@angular/router';

@Component({
  selector: 'app-coursera-dashboard',
  templateUrl: './coursera-dashboard.component.html',
  styleUrls: ['./coursera-dashboard.component.css'],
})
export class CourseraDashboardComponent implements OnInit {
  dashboardData!: CourseraDashboardStats;
  breadcrumbItems!: BreadcrumbItem[];
  descriptions!: string;
  selectedDescription!: string;
  homme: number = 0;
  femme: number = 0;
  loading: boolean = true;
  selectedCohorte: string | null = '';
  selectedCode: string | null = '';

  constructor(
    private dashboardService: CourseraDashboardService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const cohort = params.get('courseraCohorte');
      this.selectedCohorte = cohort;
      // 🔥 IMPORTANT : recharger les stats ici
      this.loadDashboard(cohort);
    });
  }

  loadDashboard(cohort: string | null) {
    if (!cohort) return;

    this.dashboardService.getDashboard(cohort).subscribe((data) => {
      this.dashboardData = data;

      // 🔥 petit délai UX pour effet smooth
      setTimeout(() => {
        this.loading = false;
      }, 600); // 400–800ms idéal
      this.loadCohortes(cohort, data.cohortes);
      this.loadGenre(data.genre);
    });
  }

  loadCohortes(currentCohort: string, listCohortes: Cohortes[]) {
    const found = listCohortes.find((c) => c.cohorte === currentCohort);

    this.selectedDescription = found?.description || 'Description inconnue';
    this.selectedCode = found?.code || 'Code inconnue';
    this.initBreadCrumbs(this.selectedCode);
  }
  loadGenre(genre: GenderStats[]) {
    const homme = genre.find((c) => c.genre === 'Homme');
    const femme = genre.find((c) => c.genre === 'Femme');

    this.homme = homme?.total ?? 0;
    this.femme = femme?.total ?? 0;
  }
  initBreadCrumbs(code: string) {
    this.breadcrumbItems = [
      { label: 'COURSERA' },
      {
        label: `SESSION ${code}`,
        url: `/dashboard/appels/coursera-dashboard`,
      },
      {
        label: 'STATISTIQUES',
        url: `/dashboard/appels/coursera-dashboard`,
      },
    ];
  }
}
